import React from 'react'

const StatCard = ({ color, count, icon, label }) => {
  return (
    <div className={`p-4 rounded-lg text-black w-full`} style={{ backgroundColor: color }}>
      <div className="flex items-center mb-2 space-x-2">
        <img src={icon} alt="" className="w-10 " />
        <div className="text-3xl font-bold">{count}</div>

      </div>
      <div className="text-xl ">{label}</div>
    </div>
  )
}

export default StatCard
